<template>
	<div>
		<transition name="fade">
			<div id="info-map-content" v-if="showInfomapContent">
				<slot name="infoMapContent"> </slot>
			</div>

			<div id="visit-point-source-content" v-if="showVisitPointSource">
				<slot name="visitPointSource"> </slot>
			</div>
		</transition>

		<div
			:name="name"
			:latitude="latitude"
			:longitude="longitude"
			:zoom="zoom"
			:theme="theme"
			:streetview="streetview"
			v-bind:id="divName"
			:class="[
				calledFrom === 'visitpoint'
					? 'map-custom-container-visit-point'
					: calledFrom === 'maps'
					? 'themap map-custom-container'
					: calledFrom === 'optimization'
					? 'map-custom-container-optimization'
					: 'themap map-custom-container-calendar',
			]"
		></div>
		<div ref="container_infowindow_map"></div>
		<vs-popup title="Google Street View" :active.sync="popupStreeViewActive" style="z-index: 99999">
			<div id="gpanorama" class="street-vien-container"></div>
		</vs-popup>
	</div>
</template>

<script>
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleMap from "@/store/map/moduleMap.js";
import VisitPoint from "@/models/VisitPoint.js";
import visitPointImg from "@/assets/images/markers/visit_point.png";
import streetviewImg from "@/assets/images/maps/google-street-view-icon-5.png";

export default {
	name: "GoogleMap",
	props: {
		name: {
			type: String,
			required: true,
			default: "themap",
		},
		latitude: {
			type: String,
			required: false,
			default: "4.686699",
		},
		longitude: {
			type: String,
			required: false,
			default: "-74.0837187",
		},
		zoom: {
			type: String,
			required: false,
			default: "12",
		},
		theme: {
			type: String,
			required: false,
			default: null,
		},
		streetview: {
			type: String,
			required: false,
			default: "false",
		},
		calledFrom: {
			type: String,
			requeride: false,
			default: "maps",
		},
		showInfomapContent: {
			type: Boolean,
			default: false,
		},
		showVisitPointSource: {
			type: Boolean,
			default: false,
		},
		markerData: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			positionArray: [],
			active: false,
			addNewDataSidebar: false,
			instanceInfo: null,
			visitPoint: new VisitPoint({}),
			currentMarkerLatLng: null,
			popupStreeViewActive: false,
			created: false,
			mounted: false,
		};
	},
	computed: {
		divName: function () {
			return this.name;
		},
		componentLoader() {
			return () => import(`./themes/${this.theme}`);
		},
		getVisitPoints() {
			return this.$store.state.moduleVisitPoint.visitPoints;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		toggleDataSidebar(val = false) {
			this.active = !this.active;
			this.addNewDataSidebar = val;
		},
		loadComponent() {
			this.componentLoader()
				.then((comp) => {
					let el = Anuket.getAnuketObj();
					const styledName = `map_styled_${this.theme}`;

					el.addStyle({
						styledMapName: styledName,
						styles: comp.default,
						mapTypeId: styledName,
					});

					el.setStyle(styledName);
				})
				.catch((error) => {
					console.warn("fail to load theme:", this.theme);
				});
		},
		loadAnuketMap(callback) {
			// Verificar si Google Maps está disponible
			if (typeof google === "undefined" || typeof google.maps === "undefined") {
				console.warn("Google Maps not loaded yet, waiting...");
				// Reintentar después de 100ms
				setTimeout(() => {
					this.loadAnuketMap(callback);
				}, 100);
				return;
			}

			let el = "#" + this.name;
			Anuket.run(el, {
				zoom: parseInt(this.zoom) || 12,
				controls: {
					position: google.maps.ControlPosition.RIGHT_BOTTOM,
					streetView: this.streetview === "false" ? false : true,
				},
				latlng: {
					lat: this.latitude,
					lng: this.longitude,
				},
			});

			if (this.theme !== null) {
				this.loadComponent();
			}

			if (this.markerData.length > 0) {
				const markers = this.markerData.map((element) => {
					let visitPoint = new VisitPoint(element);
					return this.addMarkerVisitPoint(visitPoint, true, "datarutas");
				});

				Anuket.fitBoundsMarkerGroup(markers);
			}
		},
		addMarker() {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $div = document.createElement("div");
			$div.setAttribute("id", "infoWindow");
			let $h1 = document.createElement("h1");
			$h1.textContent = "Contenido";
			$div.appendChild($h1);
			$docFragment.appendChild($div);
			// Opciones
			let options = {
				drag: true,
				icon: "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=1|1ad849",
				title: "Current position",
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: $docFragment,
				},
				onDragend: function (e, coords) {},
				onClick: function (e, coords) {
					this.currentMarkerLatLng = coords;
				},
			};
			Anuket.addMarker({lat: 6.248868, lng: -75.571748}, options);
		},
		visitPointFetchDataSelect() {
			this.$store.dispatch("moduleCommon/fetchDataSelectVisitPoint").catch((error) => {
				console.error(error);
			});
		},
		addMarkerVisitPoint(visitPoint, save = false, type = "upload", icon = visitPointImg, draggable = false) {
			const lat = visitPoint.cy;
			const lng = visitPoint.cx;
			let title = visitPoint.id ? visitPoint.id + "" : " ";
			let content = null;
			switch (type) {
				case "upload":
					content = this.generateInfowindowContentVisitPoint(visitPoint, type);
					break;
				case "datarutas":
					content = this.generateInfowindowContentVisitPoint(visitPoint, type);
					break;
				case "route":
					content = this.generateInfowindowContentPointRoute(visitPoint);
					title = visitPoint.label;
					break;
				default:
					content = this.generateInfowindowContentPoint(visitPoint);
					break;
			}
			// Opciones
			let options = {
				data: visitPoint.id || 0,
				drag: draggable,
				icon,
				title,
				info: visitPoint.vehicleLabel || visitPoint,
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content,
				},
				onDragend: (e, coords) => {
					this.visitPoint.cy = coords.lat;
					this.visitPoint.cx = coords.lng;
					this.$emit("geoInversoEmit", {
						cy: coords.lat,
						cx: coords.lng,
					});
				},
				onClick: (e, coords) => {
					this.visitPoint = visitPoint;
					this.currentMarkerLatLng = coords;
				},
				onClose: () => {
					this.instanceInfo.$destroy();
				},
			};
			const marker = Anuket.addMarker({lat, lng}, options);
			this.positionArray.push({lat, lng});
			if (save) {
				this.$store.commit("moduleMap/SAVE_VISIT_POINT_MARKER", marker);
			} else {
				Anuket.centerMap(lat, lng, {zoom: 18});
			}
			return marker;
		},
		addMarkerVisitPointCluster(visitPoint, save = false, icon = visitPointImg, draggable = false) {
			const lat = visitPoint.cy;
			const lng = visitPoint.cx;
			let title = visitPoint.id ? visitPoint.id + "" : " ";
			let content = this.generateInfowindowContentPoint(visitPoint);
			// Opciones
			let options = {
				data: visitPoint.id || 0,
				drag: draggable,
				icon,
				title,
				info: visitPoint.vehicleLabel || visitPoint,
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content,
				},
				onDragend: (e, coords) => {},
				onClick: (e, coords) => {},
				onClose: () => {
					this.instanceInfo.$destroy();
				},
			};
			const marker = Anuket.addMarkerCluster({lat, lng}, options);
			this.positionArray.push({lat, lng});
			if (save) {
				this.$store.commit("moduleMap/SAVE_VISIT_POINT_MARKER", marker);
			} else {
				Anuket.centerMap(lat, lng, {zoom: 18});
			}
			return marker;
		},
		generateInfowindowContentPoint(infoWindowData) {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.style.cssText = "text-align: justify";
			let $title = document.createElement("h4");
			let $subtitle = document.createElement("h4");
			$title.textContent = `${this.$t("VisitPoint")}`;
			$subtitle.textContent = `${this.$t("Routing.Map.VisitPoints.Identifier")}: ${
				infoWindowData.identificador == null ? "-" : infoWindowData.identificador.identification
			} `;
			let $name = document.createElement("p");
			let $visitPoint = document.createElement("p");
			let $estimatedTimeDepart = document.createElement("p");
			let $distanceFromPrevious = document.createElement("p");
			let $totalDistanceTraveled = document.createElement("p");
			let $address = document.createElement("p");
			let $avatar = document.createElement("img");
			$avatar.setAttribute("src", streetviewImg);
			$avatar.setAttribute("alt", "StreetView");
			$avatar.setAttribute("title", "StreetView");
			$avatar.className = "h-8 w-8 mr-1 cursor-pointer streetview-maps-module";
			//$avatar.style.cssText = 'width: 75px;border-radius: 50%'
			$name.innerHTML = `<strong>${this.$t("Routing.Map.VisitPoints.TimeArrival")}:</strong> ${
				infoWindowData.estimated_time_arrival
			}`;
			$visitPoint.innerHTML = `<strong>${this.$t("Routing.Table.TimeService")}</strong>: ${
				infoWindowData.time_service
			}`;
			$estimatedTimeDepart.innerHTML = `<strong>${this.$t("Routing.Table.EstimatedDepartureTime")}:</strong> ${
				infoWindowData.estimated_time_depart
			}`;
			$distanceFromPrevious.innerHTML = `<strong>${this.$t(
				"Routing.Table.DistanceFromPrevious"
			)}:</strong> ${parseFloat(infoWindowData.distance_from_previous).toFixed(2)}`;
			$totalDistanceTraveled.innerHTML = `<strong>${this.$t(
				"Routing.Table.TotalDistanceTraveled"
			)}:</strong> ${parseFloat(infoWindowData.total_distance_traveled).toFixed(2)}`;
			$address.innerHTML = `<strong>${this.$t("Routing.Table.Demand")}</strong>: ${infoWindowData.demand}`;

			$docFragment.appendChild($title);
			$docFragment.appendChild($name);
			$docFragment.appendChild($visitPoint);
			$docFragment.appendChild($estimatedTimeDepart);
			$docFragment.appendChild($address);
			$docFragment.appendChild($avatar);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
		generateInfowindowContentPointRoute(infoWindowData) {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.style.cssText = "text-align: justify";
			let $title = document.createElement("h4");
			$title.textContent = infoWindowData.label ? infoWindowData.label : "";
			let $name = document.createElement("p");
			let $visitPoint = document.createElement("p");
			let $avatar = document.createElement("img");
			$avatar.setAttribute("src", streetviewImg);
			$avatar.setAttribute("alt", "StreetView");
			$avatar.setAttribute("title", "StreetView");
			$avatar.className = "h-8 w-8 mr-1 cursor-pointer streetview-maps-module";
			//$avatar.style.cssText = 'width: 75px;border-radius: 50%'
			$name.innerHTML = `<strong>${this.$t("Routing.Map.VisitPoints.TimeArrival")}:</strong> ${
				infoWindowData.hasOwnProperty("timeWindows") ? infoWindowData.timeWindows[0].startTime : ""
			}`;
			$visitPoint.innerHTML = `<strong>${this.$t("Routing.Table.TimeService")}</strong>: ${
				infoWindowData.duration
			}`;

			$docFragment.appendChild($title);
			$docFragment.appendChild($name);
			$docFragment.appendChild($visitPoint);
			$docFragment.appendChild($avatar);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
		generateInfowindowContentVisitPoint(
			{address, city, country, cx, cy, id, identification, name},
			type = "upload"
		) {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.style.cssText = "text-align: justify";
			let $title = document.createElement("h4");
			let $subtitle = document.createElement("h4");
			$title.textContent = name;
			$subtitle.textContent = `${this.$t("Routing.Map.VisitPoints.Identifier")}: ${name === null ? "-" : name} `;
			let $name = document.createElement("p");
			let $visitPoint = document.createElement("p");
			let $address = document.createElement("p");
			let $avatar = document.createElement("img");
			$avatar.setAttribute("src", streetviewImg);
			$avatar.setAttribute("alt", "StreetView");
			$avatar.setAttribute("title", "StreetView");
			$avatar.className = "h-8 w-8 mr-1 cursor-pointer streetview-maps-module";
			//$avatar.style.cssText = 'width: 75px;border-radius: 50%'
			$name.innerHTML = `<strong>${this.$t("Routing.Table.Identification")}:</strong> ${identification}`;
			$visitPoint.innerHTML = `<strong>${this.$t("City")}</strong>: ${city}`;
			$address.innerHTML = `<strong>${this.$t("Address")}</strong>: ${address}`;

			$docFragment.appendChild($title);
			$docFragment.appendChild($name);
			if (type === "datarutas") {
				$docFragment.appendChild($visitPoint);
				$docFragment.appendChild($address);
			}
			$docFragment.appendChild($avatar);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
		mountInfowindowComponent() {
			this.$refs.container_infowindow_map.textContent = "";
			if (this.instanceInfo) {
				this.instanceInfo.$destroy();
			}
			this.instanceInfo = new ComponentClass({
				propsData: {visit_point: this.visitPoint},
			});
			this.instanceInfo.$mount();
			this.$refs.container_infowindow_map.appendChild(this.instanceInfo.$el);
		},
		openStreetView({cy, cx}) {
			Anuket.streetView({lat: parseFloat(cy), lng: parseFloat(cx)}, {container: "#gpanorama"});
			this.popupStreeViewActive = true;
		},
	},

	mounted() {
		this.mounted = true;
		this.loadAnuketMap();
		Anuket.getCurrentPosition(function (params) {});
		this.visitPointFetchDataSelect();
		document.addEventListener("click", (e) => {
			if (e.target.matches(".streetview-maps-module")) {
				this.openStreetView({
					cx: this.currentMarkerLatLng.lng,
					cy: this.currentMarkerLatLng.lat,
				});
			}
		});
	},
	created() {
		this.created = true;
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
	},
};
</script>

<style scoped>
/** custom content for map */
.map-custom-container {
	margin-top: calc(100% - 102%);
	margin-left: -28px;
	margin-right: -28px;
	height: 88vh;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}
}

.customizer-btn-map-opc {
	position: fixed;
	top: 50%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-custom-container-calendar {
	height: 560px !important;
}
.map-custom-container-optimization {
	height: 930px !important;
}
.map-custom-container-visit-point {
	height: 410px !important;
}

#info-map-content {
	position: absolute;
	margin: 10px;
	z-index: 2;
	border: 1px solid #dde2e3;
	background: white;
	padding: 10px;
	box-shadow: 1px 1px 2px 0px;
}

#visit-point-source-content {
	position: absolute;
	margin: 10px;
	z-index: 2;
	border: 1px solid #dde2e3;
	background: white;
	padding: 10px;
	box-shadow: 1px 1px 2px 0px;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}

.street-vien-container {
	width: 100%;
	height: 40vh;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}

	.street-vien-container {
		width: 100%;
		height: 60vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}

	.street-vien-container {
		width: 100%;
		height: 40vh;
	}
}
</style>
